import React from 'react'

const MetricsTab = () => {
  return (
    <div className="w-full h-full flex items-center justify-center text-gray-500 text-lg">
      Metrics Content
    </div>
  )
}

export default MetricsTab 